import React, { useEffect } from "react";
import styles from "../indent.module.css";
import { useIndentMixpanelTrack } from "../hooks/useIndentMixpanelTrack";

export default function NoAccess() {
  const { trackIndentEvent } = useIndentMixpanelTrack();

  useEffect(() => {
    trackIndentEvent("indent header", "user has landed on no access page");
  }, []);

  return (
    <div>
      <h3 className={styles.indent_noAccess}>
        Please contact your POC to get access of the module.
      </h3>
    </div>
  );
}
